import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbDatepickerComponent } from '@nebular/theme/components/datepicker/datepicker.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { CloseLeadInput } from '../../../shared/models/lead/closeLead.input.1';
import { FormsService } from '../../../shared/services/forms/forms.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-close-lead-modal',
  templateUrl: './close-lead-modal.component.html',
  styleUrls: ['close-lead-modal.scss']
})
export class CloseLeadModalComponent implements OnInit, AfterViewInit {

  @ViewChild(NbDatepickerComponent, { static: false }) closeDateEl: NbDatepickerComponent<Date>;
  @ViewChild('content', { static: false }) content: Element;
  closeLeadInput: CloseLeadInput;

  form: FormGroup;
  sending = false;
  closeDate: Date;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly translator: TranslatorService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly formsService: FormsService,
  ) {
    this.closeDate = new Date();
  }

  ngOnInit(): void {

    this.form = this.formsService.initFormClose();
  }

  ngAfterViewInit(): void {
    this.modalsHandler.closeLeadModal.subscribe(data => {

      this.closeLeadInput = new CloseLeadInput();
      this.closeLeadInput.leadId = data.leadId;
      this.resetForm();
      
      const closeDateValue = data.closeDate ? data.closeDate : moment().format('YYYY-MM-DDTHH:mm'); 
      this.form.controls['closeDate'].setValue(closeDateValue);

      const commentsValue = data.comments ? data.comments : '';
      this.form.controls['comments'].setValue(commentsValue);

      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  get f(): any {
    return this.form.controls;
  }

  closeLead(): void {

    this.bindForm();

    this.leadService.closeLead$(this.closeLeadInput).subscribe(() => {
      this.sending = true;
      this.modalService.dismissAll();
      this.leadComuService.launchReloadMyLead(this.closeLeadInput.leadId);
      this.resetForm();
      this.toasterService
        .showToast(
          'success',
          'toaster.lead_status.closed',
          'toasts.messages.lead_close_success'
        );
      this.sending = false;
    }, error => {
      this.toasterService
        .showToast(
          'error',
          'toast.title.lead_close_error',
          this.errorFormatter.formatErrors(error.graphQLErrors)
        );
      this.sending = false;
    }, () => {
      this.spinner.hide();
    });
  }

  bindForm(): void {
    this.closeLeadInput = this.formsService.bindCloseForm(this.closeLeadInput.leadId, this.form);
  }

  resetForm(): void {
    this.form.reset();
    this.closeLeadInput.closeDate = null;
    this.closeLeadInput.comments = '';
  }
}
